import React from "react";
import Modal from "../Common/Modal";
import ENV from "../../constants/environment";
import { ACTION_DISPLAY_TYPES, ACTION_TYPES } from "../../constants/enums";

interface AlreadyEnrolledModalProps {
  show: boolean;
  handleClose: (state: { show: boolean; bodyMessage: string }) => void;
  bodyMessage: string;
}

const AlreadyEnrolledModal = ({
  show,
  handleClose,
  bodyMessage,
}: AlreadyEnrolledModalProps) => {
  const onClose = () => handleClose({ show: false, bodyMessage: "" });

  return (
    <Modal
      open={show}
      onClose={onClose}
      title="Already enrolled"
      content={bodyMessage}
      className="v2 v3"
      hideCloseIcon={false}
      actions={[
        {
          title: "Log in",
          displayType: ACTION_DISPLAY_TYPES.PRIMARY,
          actionType: ACTION_TYPES.DISMISS,
          onClick: () => {
            window.location.href = ENV.BASE_NAVIGATOR_URL;
          },
          focused: true,
        },
      ]}
    />
  );
};

export default AlreadyEnrolledModal;